import React from 'react';

import Button from '../../../button/Button';
import Loading from '../../../loading/Loading';
import { DRF_LIST_TERMS_VALIDATION_ERROR_MESSAGE } from '../../../../utils/drfTermsUtil';

type DrfTermsValidationFailureScreenProps = {
  onRetry: () => void;
  onExit: () => void;
  retryLoading: boolean;
};

const DrfTermsValidationFailureScreen: React.FC<DrfTermsValidationFailureScreenProps> = ({
  onRetry,
  onExit,
  retryLoading,
}) => (
  <div
    className="fixed inset-0 z-1000 bg-background-secondary bsds-flex-direction-column"
    role="main"
    aria-label="Validação dos termos de uso"
  >
    <div className="bsds-width-100 bg-background-secondary bsds-p-16 bsds-border-bottom">
      <h2 className="text-lg font-semibold text-gray-900 bsds-mb-8">Termos de Uso</h2>
    </div>

    <div className="bsds-width-100 bsds-p-16 bsds-position-relative flex-1">
      <div className="min-h-[50vh] flex flex-col items-center justify-center gap-4">
        <p className="text-base text-gray-700 font-medium text-center">
          {DRF_LIST_TERMS_VALIDATION_ERROR_MESSAGE}
        </p>

        <div className="flex w-full max-w-xs flex-col items-center gap-4">
          <Button
            type="button"
            color="primary"
            onClick={onRetry}
            disabled={retryLoading}
            loading={retryLoading}
            className="bsds-width-100"
            aria-label="Tentar validar os termos novamente"
          >
            Tente novamente
          </Button>
          <Button
            type="button"
            color="primary"
            fill="outline"
            onClick={onExit}
            disabled={retryLoading}
            className="bsds-width-100"
            aria-label="Sair do sistema"
          >
            Sair
          </Button>
        </div>
      </div>

      {retryLoading && (
        <div
          className="absolute inset-0 flex items-center justify-center bg-background-secondary/80"
          role="status"
          aria-live="polite"
          aria-busy="true"
        >
          <Loading />
        </div>
      )}
    </div>
  </div>
);

export default DrfTermsValidationFailureScreen;
